import React from "react"

const External = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g
      id="External-group"
      data-name="External-group"
      transform="translate(-2 -2)"
    >
      <path
        id="Path_7229"
        data-name="Path 7229"
        d="M18,13v6a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V8A2,2,0,0,1,5,6h6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        id="Path_7230"
        data-name="Path 7230"
        d="M15,3h6V9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        id="Line_17"
        data-name="Line 17"
        y1="11"
        x2="11"
        transform="translate(10 3)"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default External
